export default "__VITE_ASSET__S_Len0AH__"